import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import { GAS_GUZZLER_BREADCRUMBS } from 'site-modules/calculators/constants/calculators';
import { AdUnit } from 'site-modules/shared/components/ad-unit/ad-unit';
import { CalculatorHeader } from 'site-modules/calculators/components/calculator-header/calculator-header';
import { GasGuzzlerCalculator } from 'site-modules/calculators/components/gas-guzzler-calculator/gas-guzzler-calculator';
import { TrackingHandler } from 'client/tracking/handler';
import { CalculatorMap } from 'client/tracking/maps/calculator';
import { AppraisalMap } from 'client/tracking/maps/appraisal';

export function CalculatorsGasGuzzlerUI({ isMobile = false, isVehicleSelectorOpen = false }) {
  useEffect(() => {
    TrackingHandler.useMap({ ...CalculatorMap, ...AppraisalMap });
  }, []);

  return (
    <Container tag="main" id="main-content" tabIndex={-1}>
      <CalculatorHeader
        breadcrumbs={GAS_GUZZLER_BREADCRUMBS}
        header="Car Cost vs. Gas Mileage Calculator"
        subheader="Find out if its worth trading in your gas guzzler for a more fuel efficient vehicle with Edmunds Car Cost vs. Fuel Savings calculator."
        title="Calculate your fuel cost savings estimate"
        isHeroTitle
      />
      <Row>
        <Col xs={12} lg={8} className="mb-2">
          <GasGuzzlerCalculator isTradeInVehicleSelectorOpen={isVehicleSelectorOpen} />
        </Col>
        <Col xs={12} lg={4}>
          <div className="mb-md-3_5 pb-md-3_5">
            <AdUnit adName="mrect" position={'1'} renderWhenViewable={isMobile} noRefresh />
          </div>
          {!isMobile && (
            <div className="pt-md-3_5">
              <AdUnit adName="mrect" position={'2'} noRefresh />
            </div>
          )}
        </Col>
        <div className="mb-2 mx-auto mx-lg-0 hidden-md-down">
          <AdUnit adName="edhighimpact" position={'1'} lg xl md renderWhenViewable={false} refreshable={false} />
        </div>
        <div className="my-2 mx-auto hidden-md-up">
          <AdUnit adName="medhighimpact" position={'1'} sm xs renderWhenViewable={false} refreshable={false} />
        </div>
      </Row>
    </Container>
  );
}

CalculatorsGasGuzzlerUI.propTypes = {
  isMobile: PropTypes.bool,
  isVehicleSelectorOpen: PropTypes.bool,
};

export const mapStateToProps = state => ({
  isMobile: state.mobile,
});

export const CalculatorsGasGuzzler = connect(mapStateToProps)(CalculatorsGasGuzzlerUI);
